var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"item header-notify"},[_c('a-popover',{attrs:{"trigger":"click","placement":"bottomRight"}},[_c('div',{attrs:{"title":"待办信息"}},[_c('a-badge',{attrs:{"count":_vm.num}},[_c('a-avatar',{staticStyle:{"backgroundcolor":"transparent"},attrs:{"shape":"square","icon":"bell"}})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }